// extracted by mini-css-extract-plugin
export default {"title":"BrowseBy_title__jS8W6"};